<script>
	export let list;
	export let cardBtn;
	import { onMount, createEventDispatcher } from "svelte";
	export let container;
	const dispatch = createEventDispatcher();
	var cards = [];
	var cardsOutter = null
	onMount(() => {
		cards = container.getElementsByClassName("img-card-outter");
		cardsOutter = container.getElementsByClassName('img-cards')[0];
	});
	var timestamp = null;
	var lastFunc = null;
	function dispatchArrived() {
		if (cardsOutter.getBoundingClientRect().top >= 0) {
			if (cards[0]) {
				dispatch("sliedArrived", cards[0].getElementsByClassName("img-card-anchor")[0].id);
			}
		}
		for (let i of Array.from(cards)) {
			let Bounding = i.getBoundingClientRect();
			if (
				Bounding.top <= Math.floor(Bounding.height / 2) &&
				Bounding.top >= 0
			) {
				let anchor = i.getElementsByClassName("img-card-anchor")[0];
				dispatch("sliedArrived", anchor.id);
				break;
			}
		}
	}
	window.addEventListener("scroll", function (event) {
		if (timestamp === null) {
			timestamp = Date.now();
		}
		if (Date.now() - timestamp >= 150) {
			dispatchArrived();
			timestamp = null;
			clearTimeout(lastFunc);
			lastFunc = null;
		} else {
			clearTimeout(lastFunc);
			lastFunc = null;
			lastFunc = setTimeout(dispatchArrived, 300);
		}
	});
</script>

<style>
	.img-cards .img-card-outter .img-card-anchor {
		position: absolute;
		top: -100px;
	}
	.img-cards .img-card-outter {
		background: #ffffff;
		direction: ltr;
		padding: 40px;
		position: relative;
	}
	.img-cards .img-card-outter:nth-child(2n) {
		background: #f8f8f8;
		direction: rtl;
		text-align: left;
	}
	.img-cards .img-card-outter.img-card-outter:nth-child(2n) .img-card-desc {
		text-align: left;
	}
	.img-card {
		width: 1162px;
		margin: 0 auto;
		display: flex;
		align-items: center;
	}
	.img-card .img-card-info {
		padding-left: 40px;
		padding-right: 24px;
		width: 458px;
	}
	.img-card .img-card-info .img-card-desc {
		margin-top: 16px;
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
	}
	.img-card .img-card-info .img-card-title {
		font-size: 32px;
		font-weight: 400;
		color: #000000;
		line-height: 36px;
		padding-top: 12px;
		position: relative;
	}
	.img-card .img-card-info .img-card-title::before {
		content: "";
		position: absolute;
		top: 0px;
		width: 1em;
		height: 4px;
		background-color: #2a81f6;
		left: 0px;
	}
	.img-card-img {
		font-size: 0px;
		line-height: 0px;
		border-radius: 30px;
		box-shadow: 0 4px 8px #7d8ea875;
		overflow: hidden;
	}
	.img-card-img .img-card-img-inner {
		width: 640px;
		height: 350px;
		box-shadow: 0 4px 8px #7d8ea875;
		border-radius: 0px 0px 30px 30px;
	}
	.img-card-img-title {
		height: 40px;
		width: 640px;
		background-color: #4c56dd;
		position: relative;
		border-radius: 30px 30px 0px 0px;
	}
	.img-card-img-title img {
		position: absolute;
		right: 40px;
		top: 12px;
	}
</style>

<div class="img-cards">
	{#each list as item, index}
		<div class={'img-card-outter ' + index}>
			<div class="img-card-anchor" id={item.id} />
			<div class="img-card">
				<div class="img-card-info">
					<div class="img-card-title">{item.title}</div>
					<div class="img-card-desc img-card-intro">
						{@html item.intro}
					</div>
				</div>
				<div class="img-card-img">
					<div class="img-card-img-title">
						<img src={cardBtn} alt="card-btn" />
					</div>
					<div class="img-card-img-inner">
						<img
							alt="img"
							width="640"
							height="350"
							src={item.thumb} />
					</div>
				</div>
			</div>
		</div>
	{/each}
</div>
